var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"Link",class:_vm.classList,attrs:{"to":_vm.to}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'angle-right']}}),_vm._v(" "+_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }